import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 25,
  medium: 19,
  small: 14,
  xSmall: 10
};
const VisualSearchIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement("path", { d: "M6.5 22C6.5 22.8284 7.17157 23.5 8 23.5H13V24.5H8C6.61929 24.5 5.5 23.3807 5.5 22V17H6.5V22Z", fill: "currentColor" }),
    /* @__PURE__ */ React.createElement("path", { d: "M24.5 22C24.5 23.3807 23.3807 24.5 22 24.5H17V23.5H22C22.8284 23.5 23.5 22.8284 23.5 22V17H24.5V22Z", fill: "currentColor" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 10.5C17.4853 10.5 19.5 12.5147 19.5 15C19.5 17.4853 17.4853 19.5 15 19.5C12.5147 19.5 10.5 17.4853 10.5 15C10.5 12.5147 12.5147 10.5 15 10.5ZM15 11.5C13.067 11.5 11.5 13.067 11.5 15C11.5 16.933 13.067 18.5 15 18.5C16.933 18.5 18.5 16.933 18.5 15C18.5 13.067 16.933 11.5 15 11.5Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement("path", { d: "M13 6.5H8C7.17157 6.5 6.5 7.17157 6.5 8V13H5.5V8C5.5 6.61929 6.61929 5.5 8 5.5H13V6.5Z", fill: "currentColor" }),
    /* @__PURE__ */ React.createElement("path", { d: "M22 5.5C23.3807 5.5 24.5 6.61929 24.5 8V13H23.5V8C23.5 7.17157 22.8284 6.5 22 6.5H17V5.5H22Z", fill: "currentColor" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M20.5 8.5C21.0523 8.5 21.5 8.94772 21.5 9.5C21.5 10.0523 21.0523 10.5 20.5 10.5C19.9477 10.5 19.5 10.0523 19.5 9.5C19.5 8.94772 19.9477 8.5 20.5 8.5Z",
        fill: "currentColor"
      }
    )
  );
};
VisualSearchIcon.iconName = "VisualSearchIcon";

export { VisualSearchIcon };
